let ENV = process.env.HOST_ENV || process.env.NODE_ENV || 'production'

const hobyRouteConfig = {
  route: {
    default: { module: `home`, controller: `mobile`, action: `index` },
    whiteList: ['/oauth/login'],
  },
}

const vocachatRouteConfig = {
  route: {
    default: { module: `voca-home`, controller: `mobile`, action: `index` }, // voca-home
    whiteList: ['/oauth/login'],
  },
}

const EnvConfig = {
  development: {
    host: `https://app-api-test2.yayya.live`,
    hostAdm: ``, // 测试服-后台管理功能用
    hostHybrid: '', // 测试 hybrid
    hostHybridRu: '', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    ...hobyRouteConfig,
  },
  test: {
    host: `https://app-api-test2.yayya.live`,
    hostAdm: ``, // 正式域名-后台管理功能用
    hostHybrid: '', // 灰度 hybrid
    hostHybridRu: '', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    ...hobyRouteConfig,
  },
  uat: {
    host: `https://app-api-uat.yayya.live`, // 灰度域名
    hostAdm: ``, // 正式域名-后台管理功能用
    hostHybrid: '', // 灰度 hybrid
    hostHybridRu: '', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    ...hobyRouteConfig,
  },
  production: {
    host: `https://app-api.yayya.live`, // 正式域名
    hostAdm: ``, // 正式域名-后台管理功能用
    hostHybrid: '', // 正式 hybrid
    hostHybridRu: '', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    ...hobyRouteConfig,
  },
  vocaTesting: {
    host: ``,
    hostAdm: ``,
    hostHybrid: '',
    ...vocachatRouteConfig,
  },
  vocaProd: {
    host: ``,
    hostAdm: ``,
    hostHybrid: '',
    ...vocachatRouteConfig,
  },
}

// http3 是否可用检测网址：https://http3check.net
let config = {
  localVersion: 'v1.0',
  env: ENV,
  hostRu: '', // 因为s3域名解析问题，俄罗斯使用单独的域名
}
config = Object.assign(config, EnvConfig[ENV])
export default config



// WEBPACK FOOTER //
// src/core/config.js